var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-container"},[_c('el-divider',{attrs:{"content-position":"left"}},[_vm._v("演示环境可能无法模拟上传")]),_c('vab-upload',{ref:"vabUpload",attrs:{"url":"/upload","name":"file","limit":50,"size":2}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleShow({ key: 'value' })}}},[_vm._v(" 模拟上传 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }